import {
    UPLOAD_XLSX_DOCUMENT_REQUEST,
    UPLOAD_XLSX_DOCUMENT_SUCCESS,
    UPLOAD_XLSX_DOCUMENT_FAILURE,
    UPLOAD_XLSX_DOCUMENT
} from '../../actions/import/import-from-xlsx-actions';


const initialState = {
    upload: {},
    isLoading: false,
    error: null,
};

const ImportFromXlsxReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case UPLOAD_XLSX_DOCUMENT_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case UPLOAD_XLSX_DOCUMENT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                upload: { ...action.payload },
            };
        case UPLOAD_XLSX_DOCUMENT:
            return {
                ...state,
                isLoading: false,
                upload : { ...action.payload },
            }
        case UPLOAD_XLSX_DOCUMENT_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default ImportFromXlsxReducer;